import { render, staticRenderFns } from "./DropshipOrdersStatus.vue?vue&type=template&id=39e8561a&scoped=true"
import script from "./DropshipOrdersStatus.vue?vue&type=script&lang=ts"
export * from "./DropshipOrdersStatus.vue?vue&type=script&lang=ts"
import style0 from "./DropshipOrdersStatus.vue?vue&type=style&index=0&id=39e8561a&prod&lang=scss"
import style1 from "./DropshipOrdersStatus.vue?vue&type=style&index=1&id=39e8561a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e8561a",
  null
  
)

export default component.exports